module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_02-032ebf596af97e74d89f1939d9585b59.jpg";